<template>
  <div id="app">
    <router-view v-wechat-title="$route.meta.title"></router-view>
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style>
  body,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  li,
  p,
  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  img {
    vertical-align: middle;
  }

  a {
    text-decoration: none;
  }

  body,
  html {
    font-size: 14px !important;
    width: 100%;
    height: 100%;
  }

  body {
    min-width: 1200px;
    margin: 0;
    color: rgba(0, 0, 0, .65);
    font-size: 14px !important;
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;
    font-variant: tabular-nums;
    line-height: 1.5;
    background-color: #fff;
    font-feature-settings: "tnum";
  }

  .main-wrapper-content {
    margin-bottom:50px !important;
  }

  .breadcrumb_box {
    padding: 40px 0 30px 0px;
  }

  /deep/ .el-breadcrumb {
    font-size: 15px !important;
  }

  .home-title {
    display: flex;
    justify-content: center;
    padding-bottom: 40px;
    padding-top: 60px;
    width: 1200px;
    margin: 50px auto;
  }

  .home-title img {
    width: 38px;
    height: 23px;
    margin-top: 30px;
  }

  .home-title-main {
    color: #18252C;
    font-size: 24px;
    font-weight: bold;
    line-height: 35px;
    padding: 0px 10px;
    margin: 0 20px;
  }

  .home-title-main p:nth-child(1) {
    margin-bottom: 10px;
    font-size: 35px;
  }

  #app {
    font-size: 14px !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
  }

  /** public container */
  .container {
    width: 100%;
    height: 100%;
    position: relative;
    box-sizing: border-box;
  }

  /**vue-concise-slider teaching-team style */
  #app .teaching-team .swiper-container-horizontal .slider-pagination .slider-pagination-bullet {
    height: 3px;
    width: 3px;
    margin: 10px auto;
  }

  #app .teaching-team .swiper-container-horizontal .slider-pagination .slider-pagination-bullet-active {
    height: 10px;
    width: 10px;
    background: #fff;
    border: 1px solid #555555;
  }

  /**vue-concise-slider information-center style */
  #app .information-center .slider-pagination-bullets {
    display: flex;
    top: 88%;
    left: 37%;
  }

  #app .information-center .swiper-pagination-bullet {
    width: 50px;
    height: 40px;
    color: #169bd5;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
    background-color: #fff;
    border: 1px solid #d7d7d7;
  }

  #app .information-center .slider-pagination-bullet-active-render {
    color: #fff;
    background-color: #169bd5;
    border: 1px solid #169bd5;
  }

  /**vue-concise-slider website-banner style */
  #app .website-banner .swiper-container-cursorGrab {
    cursor: pointer;
  }

  #app .website-banner .slider-pagination-bullet {
    background-color: #b8b8b8;
    position: relative;
    height: 3px;
    width: 50px;
    opacity: 1;
    border-radius: 0;
  }

  #app .website-banner .slider-pagination-bullet-active {
    background-color: #fff;
    height: 3px;
    width: 50px;
    /* animation: myfirst 5s infinite;
  animation-iteration-count: infinite;
  transition-timing-function: linear;
  -moz-animation: myfirst 5s infinite; */
    /* Firefox */
    /* -webkit-animation: myfirst 5s infinite; */
    /* Safari and Chrome */
    /* -o-animation: myfirst 5s infinite; */
    /* Opera */
  }

  /**vue-concise-slider exhibition-works style */
  #app .exhibition-works .slider-pagination-bullet {
    background-color: #b8b8b8;
    position: relative;
    height: 3px;
    width: 50px;
    opacity: 1;
    border-radius: 0;
  }

  #app .exhibition-works .slider-pagination-bullet-active {
    background-color: #fff;
    height: 3px;
    width: 50px;
  }

  /**element-ui curriculum tabs标签 style */
  .curriculum .el-tabs--border-card {
    border: 0;
    box-shadow: none;
    -webkit-box-shadow: none;
  }

  .curriculum .el-tabs--border-card>.el-tabs__header {
    border-bottom: 0;
    border-radius: 21px;
    margin-bottom: 40px;
  }

  .curriculum .el-tabs__nav-wrap {
    border-radius: 10px;
    padding: 0px 10px;
  }

  .curriculum .el-tabs--border-card {
    border: none;
  }

  .curriculum .el-tabs__nav-scroll {
    width: 100%;
    display: flex;
  }

  .curriculum .el-tabs__nav {
    float: none;
    position: none;
    width: 100%;
    -webkit-transition: -webkit-transform .3s;
    transition: -webkit-transform .3s;
    transition: transform .3s;
    transition: transform .3s, -webkit-transform .3s;
    transition: transform .3s, -webkit-transform .3s;
    z-index: 2;
    display: flex;
  }

  .curriculum .el-tabs__item {
    margin: 12px 12px !important;
    text-align: center;
    padding: 0 12px !important;;
    height: 24px;
    border-radius: 6px;
    font-weight: bold;
    color: #FABE00;
    line-height: 24px;
    border: none;
  }

  .curriculum .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
    margin: 12px 12px !important;;
    text-align: center;
    padding: 0 12px !important;
    height: 24px;
    border-radius: 6px;
    font-weight: bold;
    color: #FABE00;
    line-height: 24px;
    border: 1px solid white;
  }

  .curriculum .el-tabs--bottom .el-tabs--left>.el-tabs__header .el-tabs__item:nth-child(2),
  .el-tabs--bottom .el-tabs--right>.el-tabs__header .el-tabs__item:nth-child(2),
  .el-tabs--bottom.el-tabs--border-card>.el-tabs__header .el-tabs__item:nth-child(2),
  .el-tabs--bottom.el-tabs--card>.el-tabs__header .el-tabs__item:nth-child(2),
  .el-tabs--top .el-tabs--left>.el-tabs__header .el-tabs__item:nth-child(2),
  .el-tabs--top .el-tabs--right>.el-tabs__header .el-tabs__item:nth-child(2),
  .el-tabs--top.el-tabs--border-card>.el-tabs__header .el-tabs__item:nth-child(2),
  .el-tabs--top.el-tabs--card>.el-tabs__header .el-tabs__item:nth-child(2) {
    padding-right: 0px;
    padding-left: 0px;
  }

  /**element-ui curriculum tabs标签 style */
  .course .el-radio-button__inner {
    border: 0;
  }

  .course .el-radio-group {
    display: block;
    text-align: left;
    margin-top: 11px;
  }

  .course .el-form-item--medium .el-form-item__label {
    line-height: 55px;
    text-align: center;
    font-weight: bold;
  }

  .course .el-radio-button:first-child .el-radio-button__inner {
    border-left: 0;
  }

  .course .el-radio-button__orig-radio:checked+.el-radio-button__inner {
    border-radius: 5px;
  }

  .course .el-form-item {
    margin-bottom: 0;
  }

  /**element-ui ordem  tabs*/
  #app .ordem .el-tabs__nav-wrap::after {
    background-color: #f8f8f8;
  }

  /**element-ui circle---personal  tabs*/
  #app .circle .el-tabs__item.is-active,
  #app .Publish .el-tabs__item.is-active {
    background: #FABE00;
    color: #fff;
    width: 110px;
    height: 40px;
    text-align: center;
    border-radius: 10px;
  }

  #app .circle .el-tabs--left .el-tabs__item.is-left,
  #app .Publish .el-tabs--left .el-tabs__item.is-left,
  #app .personal-center .el-tabs--left .el-tabs__item.is-left {
    text-align: center;
  }

  #app .circle .el-tabs__active-bar,
  #app .Publish .el-tabs__active-bar,
  #app .circle .el-tabs__nav-wrap::after,
  #app .Publish .el-tabs__nav-wrap::after,
  #app .personal-center .el-tabs__active-bar,
  #app .personal-center .el-tabs__nav-wrap::after {
    background: none;
  }

  #app .circle .circle-center_tabs .el-tabs__header,
  #app .Publish .circle-center_tabs .el-tabs__header {
    background-color: #f5f8f8;
    margin-top: 28px;
    border-radius: 10px;
    padding: 14px 0;
    font-size: 16px;
    /* -webkit-user-select: none; */
  }

  #app .circle .circle-center_tabs .el-tabs__item,
  #app .Publish .circle-center_tabs .el-tabs__item {
    font-weight: 600;
    color: #747c80;
    padding: 0 12px;
    width: auto;
    height: 24px;
    line-height: 24px;
    font-size: 15px;
  }

  #app .circle .circle-center_tabs .el-tabs__item.is-active,
  #app .Publish .circle-center_tabs .el-tabs__item.is-active {
    background: #fff;
    color: #FABE00 !important;
  }

  /**element-ui login  input*/
  #app .login .el-input__prefix,
  .el-input__suffix {
    top: -10%;
  }

  #app .login .el-form-item__error {
    line-height: 0;
    padding-top: 0;
    left: -20%;
  }

  #app .login .el-input__inner {
    background-color: #e2ecfe;
    border: 0;
    margin: 0 0 20px -100px;
    padding-left: 40px;
    width: 390px;
    height: 60px;
    box-sizing: border-box;
    font-size: 16px;
    color: #97999f;
    outline: none;
    border: 1;
    border-radius: 35px;
  }

  #app .login .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #97999f;
  }
  
  
</style>



// WEBPACK FOOTER //
// src/App.vue